import Results from './results.js';

export default Results;